var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bao-widget-display',{attrs:{"widget":_vm.widget,"previewMode":_vm.previewMode,"showConversationsView":_vm.showConversationsView},scopedSlots:_vm._u([{key:"chart",fn:function(){return [_c('div',[_vm._t("chart")],2)]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }